"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Cardio = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Cardio, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Cardio);

  function Cardio() {
    (0, _classCallCheck2["default"])(this, Cardio);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Cardio, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M18.125,16.3043478 C18.125,16.5683478 17.915,16.7826087 17.65625,16.7826087 C17.3975,16.7826087 17.1875,16.5683478 17.1875,16.3043478 L17.1875,13.9130435 C17.1875,13.6490435 17.3975,13.4347826 17.65625,13.4347826 C17.915,13.4347826 18.125,13.6490435 18.125,13.9130435 L18.125,16.3043478 Z M11.5625,2.91304348 C11.5625,2.38504348 11.9834375,1.95652174 12.5,1.95652174 C13.0165625,1.95652174 13.4375,2.38504348 13.4375,2.91304348 C13.4375,3.44104348 13.0165625,3.86956522 12.5,3.86956522 C11.9834375,3.86956522 11.5625,3.44104348 11.5625,2.91304348 L11.5625,2.91304348 Z M7.8125,16.3043478 C7.8125,16.5683478 7.6025,16.7826087 7.34375,16.7826087 C7.085,16.7826087 6.875,16.5683478 6.875,16.3043478 L6.875,13.9130435 C6.875,13.6490435 7.085,13.4347826 7.34375,13.4347826 C7.6025,13.4347826 7.8125,13.6490435 7.8125,13.9130435 L7.8125,16.3043478 Z M18.125,11.5217391 C18.125,9.14095652 15.4175,5.73382609 13.6409375,4.42052174 C14.0834375,4.07043478 14.375,3.52808696 14.375,2.91304348 C14.375,1.858 13.5340625,1 12.5,1 C11.4659375,1 10.625,1.858 10.625,2.91304348 C10.625,3.52808696 10.9165625,4.07043478 11.3590625,4.42052174 C9.5825,5.73382609 6.875,9.14095652 6.875,11.5217391 L5,11.5217391 L5,20.6086957 C5,21.9296522 6.0490625,23 7.34375,23 C8.6384375,23 9.6875,21.9296522 9.6875,20.6086957 L9.6875,11.5217391 L7.8125,11.5217391 C7.8125,8.89130435 11.7003125,4.94086957 12.4878125,4.82513043 C13.2996875,4.94086957 17.1875,8.89130435 17.1875,11.5217391 L15.3125,11.5217391 L15.3125,20.6086957 C15.3125,21.9296522 16.3615625,23 17.65625,23 C18.9509375,23 20,21.9296522 20,20.6086957 L20,11.5217391 L18.125,11.5217391 Z"
      }));
    }
  }]);
  return Cardio;
}(_react["default"].PureComponent);

var _default = Cardio;
exports["default"] = _default;